import React, { useEffect, useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function OfferBlock() {
  const today = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const [viewers, setViewers] = useState(getRandomInt(40, 80));
  const [spots, setSpots] = useState(getRandomInt(7, 15));
  useEffect(() => {
    const viewerInterval = setInterval(() => {
      setViewers(getRandomInt(40, 80));
    }, getRandomInt(30000, 60000));
    const spotsInterval = setInterval(() => {
      setSpots(getRandomInt(7, 15));
    }, getRandomInt(30000, 60000));
    return () => {
      clearInterval(viewerInterval);
      clearInterval(spotsInterval);
    };
  }, []);
  return <section className="py-12 bg-background-dark" data-id="element-228">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-229">
        <FadeIn data-id="element-230">
          <div className="bg-[#1A1A1A] border-2 border-primary rounded-3xl p-8 md:p-12 text-center shadow-[0_0_30px_rgba(217,95,2,0.15)]" data-id="element-231">
            <h2 className="text-2xl md:text-3xl font-black text-primary font-heading uppercase tracking-wider mb-2" data-id="element-232">
              OFERTA VÁLIDA
            </h2>
            <p className="text-white text-sm md:text-base mb-8" data-id="element-233">
              Solo por hoy: <span className="font-medium" data-id="element-234">{today}</span>
            </p>

            <div className="flex flex-col items-center mb-8" data-id="element-235">
              <span className="text-2xl text-gray-500 line-through font-bold mb-3 notranslate" translate="no" data-id="element-236">
                $49.975 ARS
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-237">
                <span className="text-5xl md:text-7xl font-black text-primary font-heading notranslate" translate="no" data-id="element-238">
                  $19.990
                </span>
                <span className="text-2xl md:text-3xl font-black text-primary font-heading notranslate" translate="no" data-id="element-239">
                  ARS
                </span>
              </div>
            </div>

            <p className="text-white text-lg md:text-xl leading-relaxed max-w-xl mx-auto mb-8" data-id="element-240">
              Llevate el Pack Bases del Entrenamiento de Fuerza con{' '}
              <span className="text-primary font-bold" data-id="element-241">
                140 EJERCICIOS ANALIZADOS EN PROFUNDIDAD
              </span>{' '}
              + 5 bonos de regalo
            </p>

            <div className="mt-6 border border-primary/30 rounded-xl p-4 max-w-sm mx-auto" data-id="element-242">
              <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-2.5 items-center" data-id="element-243">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse shrink-0" data-id="element-244" />
                <span className="text-gray-300 text-sm" data-id="element-245">
                  <span className="font-bold text-white" data-id="element-246">{viewers}</span>{' '}
                  personas viendo esta página ahora
                </span>
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shrink-0" data-id="element-247" />
                <span className="text-gray-300 text-sm" data-id="element-248">
                  Quedan <span className="font-bold text-urgency" data-id="element-249">{spots}</span>{' '}
                  cupos con precio promocional
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}